var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a_404 main-box text-center"},[_c('el-image',{attrs:{"src":require('../assets/img/i.png'),"fit":"cover"}}),_c('p',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }